import {getList} from "@/api/task";

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

function newestTask(items) {
    return (items || []).reduce((newest, item) => {
        if (!newest) {
            return item;
        }
        return new Date(item.start_time || 0) > new Date(newest.start_time || 0) ? item : newest;
    }, null);
}

// id самой свежей задачи этого типа — запоминаем до запуска, чтобы потом отличить новую
export async function getLatestTaskId(company_id, task_type) {
    try {
        const result = await getList(company_id, {task_type, size: 20});
        return newestTask(result.data.items)?.id || null;
    } catch (e) {
        return null;
    }
}

// Эндпоинты запуска отвечают 202 без тела, поэтому новую задачу ищем в списке
export async function waitForNewTask(company_id, task_type, previousId, attempts = 8, delay = 1000) {
    for (let i = 0; i < attempts; i++) {
        await sleep(delay);
        try {
            const result = await getList(company_id, {task_type, size: 20});
            const task = newestTask(result.data.items);
            if (task && task.id !== previousId) {
                return task;
            }
        } catch (e) {
            // пробуем ещё раз
        }
    }
    return null;
}

// fallbackToList: если задачу не нашли — открыть список задач этого типа (он показывает задачи активной компании)
export async function openStartedTask(router, company_id, task_type, previousId, fallbackToList = true) {
    const task = await waitForNewTask(company_id, task_type, previousId);
    if (task) {
        await router.push({name: 'task-detail', params: {id: task.id}});
        return true;
    }
    if (fallbackToList) {
        await router.push({name: 'tasks', query: {task_type}});
        return true;
    }
    return false;
}
